// extracted by mini-css-extract-plugin
export var container = "_58-0";
export var disabled = "_58-4";
export var fullWidth = "_58-3";
export var lined = "_58-1";
export var selected = "_58-5";
export var tab = "_58-2";